import {
  getCountries,
  getStates,
  getPayoutMethods,
  getPendingPayouts,
  getCryptoCurrencyPayoutVerificationCode,
  postCryptoPayout,
  getPayoutBankAccounts,
  postEcheckPayout,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';
import { debug } from 'util';

Vue.use(Vuex);

const state = {
  selectedBankAccount: {},
  selectedEcheck: {
    id: 0,
  },
  bankAccounts: [],
  currentState: '',
  countries: [],
  states: [],

  account_echeck_id: -1,
  file: '',
  Name_Account: '',
  Country: '',
  State: '',
  Routing_Code: '',
  Account_Number: '',
  Account_Type: '',
  Beneficiary_Name: '',
  cod_transaction: '',
  verificationCode: '',
  verificationCodeModel: {},
  phoneNumber: '',
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setIsBankAccount(state, val) {
    // if (!val) {
    //   state.account_bank_wire_id = null;
    // }
    state.isNewAccount = val;
  },
  unSet(state, val) {
    // if (!val) {
    //   state.account_bank_wire_id = null;
    // }
    state.isNewAccount = val;
  },
  setIntermediated(state) {
    state.isIntermediated = !state.isIntermediated;
  },
  setVerificationCodeModel(state, val) {
    state.verificationCodeModel = val;
  },
  setVerificationCodeStatus(state, row) {
    state.verificationCodeStatus = {
      ...state.verificationCodeStatus,
      ...row,
    };
  },
  setPayoutCompleteCodeStatus(state, row) {
    state.payoutCompleteCodeStatus = {
      ...state.payoutCompleteCodeStatus,
      ...row,
    };
  },
  setCountries(state, cols) {
    state.countries = cols;
  },
  setStates(state, cols) {
    state.states = cols;
  },
  setPayoutBankAccounts(state, cols) {
    state.bankAccounts = cols;
  },
  setCodTransaction(state, val) {
    state.cod_transaction = val;
  },
  setSelectedEcheck(state, echeck) {
    state.selectedEcheck.id = echeck.id;
    state.account_echeck_id = echeck.id;
    state.Country = echeck.bank_country;
    state.Routing_Code = echeck.bank_route_code;
    state.Account_Type = echeck.account_type;
    state.Name_Account = echeck.customer_account;
    state.Account_Number = echeck.bank_account;
    state.Beneficiary_Name = echeck.bank_name;
    // State: "",
    // Beneficiary_Name: "",
    // cod_transaction: "",
  },
  resetSelectedEcheck(state, rootState) {
    state.selectedEcheck.id = 0;
  },
};

const actions = {
  tryGetCountries({ commit, rootState }) {
    getCountries(rootState.settings.brandSettings.book_id, rootState.settings.selectedLocale.short_code).then(r => {
      if (r.data.IsSuccess) {
        commit('setCountries', r.data.Data);
      }
    });
  },
  tryGetStates({ commit }, iso2) {
    if (iso2)
      getStates(iso2).then(r => {
        if (r.data.IsSuccess) {
          commit('setStates', r.data.Data);
        }
      });
  },
  tryGetPayoutBankAccounts({ commit }) {
    const method = 'echeck';
    getPayoutBankAccounts(method).then(r => {
      if (r.data.IsSuccess) {
        commit('setPayoutBankAccounts', r.data.Data.data);
      }
    });
  },
  tryPostEcheckPayout({ commit, dispatch }, formData) {
    commit('setPayoutCompleteCodeStatus', { loading: true });
    postEcheckPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status === 'OK') {
          dispatch('payoutStore/tryGetPendingPayouts', null, { root: true });
          commit('setCodTransaction', r.data.Data.payout.cod_transaction);
          commit('setPayoutCompleteCodeStatus', {
            success: true,
            error: false,
          });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + r.data.Data.error_code || r.data.Data.message),
          });
        }
      } else {
        if (r.data.ExceptionMessage[0] === 'ROLLOVER_REACHED') {
          commit('payoutStore/setRollover', { error: true }, { root: true });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: r.data.ExceptionMessage[0],
          });
        }
      }
      commit('setPayoutCompleteCodeStatus', { loading: false });
      dispatch('player/tryGetBalance', null, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

/*

BANK ACCOUNT MODEL
{
      "id": 1,
      "account_type": "C",
      "active": true,
      "bank_account_number": "273737373733737",
      "bank_country": "Te",
      "bank_international_account_number": "636262",
      "bank_name": "Test ",
      "bank_street_address": null,
      "bank_state": null,
      "bank_city": null,
      "bank_zip": null,
      "bank_phone_number": "98682876",
      "bank_route_code": "63626",
      "bank_sort_code": "636366",
      "bank_swift_code": "",
      "customer_account": "MB143913",
      "name_on_account": null,
      "is_default": false,
      "is_approved": false,
      "created_at": "2018-08-15 15:28:50",
      "deleted_at": null,
      "updated_at": "2018-08-15 15:28:50",
      "created_by": "MB143913",
      "deleted_by": null,
      "updated_by": null,
      "bank_intermediaries": []
  }

*/
